import React from "react";
import error from "../../assets/img/404.jpg";

const NotFound = () => {
  return (
    <div className="flex h-screen items-center justify-center">
      <div className="text-center">
        <img className="mx-auto mb-8 h-72" src={error} alt="404" />
        <h1 className="mb-2 text-4xl font-bold dark:text-white">
          Halaman Tidak Tersedia
        </h1>
        <p className="mb-5 text-lg text-gray-600 dark:text-white">
          Alamat yang dituju tidak tersedia.
        </p>
        <p className="mb-5 text-lg text-gray-600 dark:text-white">
          Pastikan alamat yang anda masukkan sudah benar dan coba beberapa saat
          lagi.
        </p>
      </div>
    </div>
  );
};

export default NotFound;
